// the Uniswap Default token list lives here
export const DEFAULT_TOKEN_LIST_URL = ''

export const DEFAULT_LIST_OF_LISTS: string[] = ['https://tokens.larissa.network/tokens.json']
